// translations/buttons.ts
const labelTranslations: Record<string, Record<string, string>> = {
  heroText: {
    en: 'Your horse becomes your partner. Our process builds trust, clarity, and performance.',
    pl: 'Twój koń staje się Twoim partnerem. Nasz proces buduje zaufanie, jasność i wydajność.',
  },
  heroSubtext: {
    en: 'Limited training slots available.',
    pl: 'Ograniczone miejsca w treningu.',
  },
  heroTextShort: {
    en: 'Your horse becomes your partner.',
    pl: 'Twój koń staje się Twoim partnerem.',
  },
  aboutUsText: {
    en: `
    Urban Equestrian is a family stable where we combine work with passion. Our main trainer is Barbara Urban-Jimenez, who gained experience 
    in working with horses during her studies.
    After defending her master's degree in Hippology and Horsemanship, she went to the United States, where she worked as a manager of 
    a sports stable. She was responsible not only for organizing the work of the entire center, but also - and above all - 
    for training and preparing horses for safe work under a rider.\n\n
    After returning to Poland, she worked as a training rider at the Służewiec Racecourse in Warsaw. Then she went to the Netherlands, 
    where she gained experience in one of the most famous dressage stables in Europe. At Van olst Horses, she worked with Grand Prix horses. 
    Then she moved to Germany, where she worked in a sports stable with a jumping profile as a house rider and prepared horses for starts 
    from break-in to the Grand Prix class.\n\n
    Experience gained in Poland and abroad as an instructor allows for comprehensive training of the rider also in English.\n\n
    Basia is a licensed PZJ trainer and has current 3rd class judging qualifications in dressage, show jumping and eventing. 
    In her work, she pays particular attention to continuous training and acquiring knowledge about horses and equestrianism 
    in general in line with the latest research and discoveries.\n\n
    In our stable, we understand that the well-being of horses is the best investment in a long-term and good relationship with them. 
    By taking care of horses, we create conditions for achieving full harmony in equestrianism, where both the rider and the horse derive 
    joy and satisfaction from working together.
    `,
    pl: `Urban Equestrian to stajnia rodzinna, w której pracę łączymy z pasją. Naszym głównym szkoleniowcem jest Barbara Urban-Jimenez, 
    która doświadczenie w pracy z końmi zdobywała już podczas studiów.
    Po obronieniu tytułu magistra inżyniera na kierunku Hipologia i Jeździectwo wyjechała do Stanów Zjednoczonych, gdzie pracowała na 
    stanowisku managera stajni sportowej. Zajmowała się nie tylko organizacja pracy całego ośrodka, ale także - i przede wszystkim -  
    treningiem i przygotowaniem koni do bezpiecznej pracy pod jeźdźcem.\n\n
    Po powrocie do kraju, jako jeździec treningowy, pracowała na Torze Wyścigowym Służewiec w Warszawie. Następnie wyjechała do Holandii, 
    gdzie zdobywała doświadczenie w jednej z najsłynniejszych stajni ujeżdżeniowych w Europie. W Van olst Horses pracowała z końmi klasy Grand Prix.
    Następnie przeniosła się do Niemiec, gdzie w stajni sportowej o profilu skokowym pracowała jako jeździec domowy i przygotowywała konie 
    do startów od zajeżdżenie do klasy Grand Prix włącznie.\n\n
    Zdobyte w kraju i za granicą doświadczenie w pracy instruktora pozwala na wszechstronny trening jeźdźca również w języku angielskim.\n\n 
    Basia jest licencjonowanym szkoleniowcem PZJ oraz posiada aktualne uprawnienia sędziowskie 3 klasy w ujeżdżeniu, skokach przez 
    przeszkody i WKKW. W swojej pracy szczególnie zwraca uwagę na ciągłe doszkalanie się i zdobywanie zgodnej z najnowszymi badaniami i 
    odkryciami wiedzy na temat koni i jeździectwa w ogóle.\n\n
    W naszej stajni rozumiemy, że dobrostan koni to najlepsza inwestycja w długotrwałą i dobrą relację z nimi. Dbając o konie, tworzymy 
    warunki do osiągnięcia pełnej harmonii w jeździectwie, gdzie zarówno jeździec, jak i koń czerpią radość i satysfakcję ze wspólnej pracy.
    `,
  },
  aboutUsTextShort: {
    en: `Barbara Urban-Jimenez is a licensed PZJ trainer with 15+ years of international experience across the US, Netherlands, Germany, and Poland. She specializes in partnership-based training that prioritizes horse well-being and biomechanical understanding. Her work has transformed 150+ horses and riders.`,
    pl: `Barbara Urban-Jimenez to licencjonowany szkoleniowiec PZJ z ponad 15 latami doświadczenia międzynarodowego. Specjalizuje się w treningu opartym na partnerstwie, który priorytetowo traktuje dobrostan konia i zrozumienie biomechaniki. Jej praca zamieniła ponad 150 koni i jeźdźców.`,
  },
  offerIntro: {
    en: 'Premium pension and training for serious equestrians.',
    pl: 'Pensjonat i trening premium dla poważnych jeźdźców.',
  },
  offerTextOne: {
    en: `Comprehensive work with horses:\n\n
        \n- Breaking in and comprehensive preparation of young horses for riding
        \n- Correction of difficult horses
        \n- Work with horses after transitions
        \n- Work from the ground
    `,
    pl: `Kompleksowa praca z końmi:\n\n
        \n- Zajeżdżanie i wszechstronne przygotowanie młodych koni do jazdy
        \n- Korekta koni trudnych
        \n- Praca z końmi po przejściach
        \n- Praca z ziemi, longowanie, zajeżdżanie    
`,
  },
  offerTextTwo: {
    en: `Our approach to horses and horse riding is holistic. We take care of all aspects of the horse's life - physical, mental and emotional. We attach great importance to teaching the basics. We want cooperation at the horse-rider level to take place in understanding the horse's biomechanics, without the use of violence and to be based primarily on partnership.\n\n
        \n- Horse riding lessons for children and adults
        \n- Rider training at various stages of training
        \n- A variety of trails
    `,
    pl: `Nasze podejście do koni i jeździectwa jest holistyczne. Dbamy o wszystkie aspekty życia wierzchowca – te fizyczne, psychiczne i emocjonalne. Przykładamy dużą wagę do nauki podstaw. Zależy nam, aby współpraca na poziomie koń – jeździec odbywała się w zrozumieniu biomechaniki konia, bez użycia przemocy i była oparta przede wszystkim na partnerstwie.\n\n
        \n- Nauka jazdy konnej dla dzieci i dorosłych
        \n- Trening jeźdźca na różnym etapie wyszkolenia
        \n- Wyjazdy w teren
    `,
  },
  offerTextThree: {
    en: 'Hippotherapy\n\nRehabilitation with the help of a horse, affecting psychomotor, psychomotor, sensory, mental and social. It aims to improve the physical and mental fitness of the patient. Conducted with the consent of a doctor, in the absence of contraindications.',
    pl: 'Hipoterapia\n\nRehabilitacja przy pomocy konia, oddziaływująca jednocześnie psychomotorycznie, psychoruchowo, sensorycznie, psychicznie i społecznie. Ma na celu poprawienie sprawności fizycznej oraz psychicznej pacjenta. Prowadzona za zgodą lekarza, przy braku przeciwwskazań!',
  },
  methodText: {
    pl: `Nasze metody treningowe opieramy głównie na zrozumieniu psychiki koni, wychodząc z założenia, że bez podstaw teoretycznych nie ma dobrej praktyki. Później -  to już kwestia wyczucia i doświadczenia… Do każdego konia podchodzimy indywidualnie, czerpiąc zarówno ze szkoły klasycznej jak i naturalnej. Staramy się odrzucić schemat dominacji, a w wierzchowcu szukamy przede wszystkim partnera, który nam ufa i dzięki temu jest chętny do współpracy.
    \n\nIm większa wiedza na temat psychiki oraz biomechaniki ciała konia – tym lepsze efekty treningowe.`,
    en: `Our training methods are based mainly on understanding the psyche of horses, assuming that there is no good practice without theoretical foundations. Later - it is a matter of intuition and experience... We approach each horse individually, drawing from both the classical and natural schools. We try to reject the dominance scheme, and in the mount we look primarily for a partner who trusts us and is therefore willing to cooperate.
    \n\nThe greater the knowledge about the psyche and biomechanics of the horse's body - the better the training effects.`,
  },
  forWhomTitle: {
    en: 'Who we work with',
    pl: 'Dla kogo pracujemy',
  },
  forWhomText: {
    en: 'Serious equestrians committed to partnership-based training. Riders seeking long-term relationships with their horses and measurable results. Those who understand that quality training is an investment.',
    pl: 'Poważni jeźdźcy zaangażowani w trening oparty na partnerstwie. Jeźdźcy poszukujący długoterminowych relacji ze swoimi końmi i mierzalnych wyników. Ci, którzy rozumieją, że jakościowy trening to inwestycja.',
  },
  notForWhomTitle: {
    en: 'Not for everyone',
    pl: 'Nie dla każdego',
  },
  notForWhomText: {
    en: "We focus on quality, not volume. We don't accept quick fixes or dominance-based methods. Limited slots mean we choose clients who align with our philosophy.",
    pl: 'Skupiamy się na jakości, nie na ilości. Nie akceptujemy szybkich rozwiązań ani metod opartych na dominacji. Ograniczone miejsca oznaczają, że wybieramy klientów zgodnych z naszą filozofią.',
  },
  proofMetrics: {
    en: '15+ years of international experience | 150+ horses trained | 95% client retention',
    pl: '15+ lat doświadczenia międzynarodowego | 150+ koni wyszkolonych | 95% zatrzymanie klientów',
  },
  ctaApplyTraining: {
    en: 'Apply for Private Training',
    pl: 'Złóż wniosek o trening prywatny',
  },
  ctaApplyConsultation: {
    en: 'Request a Private Consultation',
    pl: 'Zaproś się na konsultację',
  },
  name: {
    en: 'Name',
    pl: 'Imie',
  },
  date: {
    en: 'Date',
    pl: 'Data',
  },
  from: {
    en: 'From',
    pl: 'Od',
  },
  to: {
    en: 'To',
    pl: 'Do',
  },
  status: {
    en: 'Status',
    pl: 'Status',
  },
  available: {
    en: 'Available',
    pl: 'Dostępny',
  },
  break: {
    en: 'Break',
    pl: 'Przerwa',
  },
  blocked: {
    en: 'Blocked',
    pl: 'Zablokowany',
  },
  booked: {
    en: 'Booked',
    pl: 'Zarezerwowane',
  },
  confirmed: {
    en: 'Confirmed',
    pl: 'Potwierdzony',
  },
  done: {
    en: 'Done',
    pl: 'Dokonany',
  },
  clientAbsent: {
    en: 'Client Absent',
    pl: 'Klient nieobecny',
  },
  cancelled: {
    en: 'Cancelled',
    pl: 'Odwołany',
  },
  hr: {
    en: 'hr',
    pl: 'gdz',
  },
  min: {
    en: 'min',
    pl: 'm',
  },
  yes: {
    en: 'yes',
    pl: 'tak',
  },
  no: {
    en: 'no',
    pl: 'nie',
  },
  logout: {
    en: 'Logout',
    pl: 'Wyloguj',
  },
  weekday: {
    en: 'Weekday',
    pl: 'Dzień powszedni',
  },
  serviceName: {
    en: 'Name',
    pl: 'Nazwa',
  },
  translations: {
    en: 'Translations',
    pl: 'Tłumaczenia',
  },
  selectTranslations: {
    en: 'Select translations',
    pl: 'Wybierz tłumaczenia',
  },
  enabled: {
    en: 'Enabled',
    pl: 'Włączony',
  },
  disabled: {
    en: 'Disabled',
    pl: 'Wyłączony',
  },
  serviceNameEN: {
    en: 'Name (EN)',
    pl: 'Nazwa (EN)',
  },
  serviceNameES: {
    en: 'Name (ES)',
    pl: 'Nazwa (ES)',
  },
  serviceNamePL: {
    en: 'Name (PL)',
    pl: 'Nazwa (PL)',
  },
  serviceNameUK: {
    en: 'Name (UK)',
    pl: 'Nazwa (UK)',
  },
  service: {
    en: 'Service',
    pl: 'Usługa',
  },
  duration: {
    en: 'Duration',
    pl: 'Czas trwania',
  },
  price: {
    en: 'Price',
    pl: 'Cena',
  },
  individualLessons: {
    en: 'Individual Lessons',
    pl: 'Zajęcia Indywidualne',
  },
  pairedLessons: {
    en: 'Paired Lessons',
    pl: 'Zajęcia w Parze',
  },
  oneHour: {
    en: '1 Hour',
    pl: '1 Godzina',
  },
  fourtyFiveToSixtyMinutes: {
    en: '45-60 Minutes',
    pl: '45-60 Minut',
  },
  fourtyFiveMinutes: {
    en: '45 Minutes',
    pl: '45 Minut',
  },
  fiftyMinutes: {
    en: '50 Minutes',
    pl: '50 Minut',
  },
  halfHour: {
    en: '30 Minutes',
    pl: '30 Minut',
  },
  seventyFiveMinutes: {
    en: '75 Minutes',
    pl: '75 Minut',
  },
  description: {
    en: 'Description',
    pl: 'Opis',
  },
  training: {
    en: 'Training',
    pl: 'Trening',
  },
  individualTraining: {
    en: 'Individual Training',
    pl: 'Trening Indywidualny',
  },
  pairedTraining: {
    en: 'Paired Training',
    pl: 'Trening w Parze',
  },
  jumpTraining: {
    en: 'Jump Training',
    pl: 'Trening Skokowy',
  },
  individualJumpTraining: {
    en: 'Individual Jump Training',
    pl: 'Trening Skokowy Indywidualny',
  },
  privateHorseTraining: {
    en: 'Private Horse Training',
    pl: 'Trening na Koniu Prywatnym',
  },
  lunge: {
    en: 'Lunge',
    pl: 'Lonża',
  },
  youngestLessons: {
    en: 'Lessons for the Youngest',
    pl: 'Zajęcia dla Najmłodszych',
  },
  lungingAndGroundWork: {
    en: 'Lunging and Ground Work',
    pl: 'Nauka Lonżowania i Pracy z Ziemi',
  },
  trail: {
    en: 'Trail',
    pl: 'Teren',
  },
  trailRide: {
    en: 'Trail Ride',
    pl: 'Wyjazd w Teren',
  },
  lesson: {
    en: 'Lesson',
    pl: 'Lekcja',
  },
  horseRental: {
    en: 'Horse Rental',
    pl: 'Wynajem Konia',
  },
  passes: {
    en: 'Passes',
    pl: 'Karnety',
  },
  pension: {
    en: 'Pension',
    pl: 'Pensjonat',
  },
  horseTraining: {
    en: 'Horse Training',
    pl: 'Trening Konia',
  },
  otherServices: {
    en: 'Other Services',
    pl: 'Inne Usługi',
  },
  boxOrFreeRun: {
    en: 'Box or Free Run',
    pl: 'Boks lub Wolny Wybieg',
  },
  individuallyDetermined: {
    en: 'Individually Determined',
    pl: 'Ustalany Indywidualnie',
  },
  actions: {
    en: 'Actions',
    pl: 'Działania',
  },
  action: {
    en: 'Action',
    pl: 'Działanie',
  },
  admin: {
    en: 'Admin',
    pl: 'Admin',
  },
  shortInfo: {
    en: 'Short Information',
    pl: 'Krótka informacja',
  },
  shortInfoEN: {
    en: 'Short Information (EN)',
    pl: 'Krótka informacja (EN)',
  },
  shortInfoES: {
    en: 'Short Information (ES)',
    pl: 'Krótka informacja (ES)',
  },
  shortInfoPL: {
    en: 'Short Information (PL)',
    pl: 'Krótka informacja (PL)',
  },
  shortInfoUK: {
    en: 'Short Information (UK)',
    pl: 'Krótka informacja (UK)',
  },
  finish: {
    en: 'Finish',
    pl: 'Zakończ',
  },
  resource: {
    en: 'Resource',
    pl: 'Zasób',
  },
  type: {
    en: 'Type',
    pl: 'Typ',
  },
  staffFor: {
    en: 'Staff for',
    pl: 'Personel do',
  },
  business: { en: 'Business', pl: 'Biznes' },
  email: { en: 'Email', pl: 'E-mail' },
  phone: { en: 'Phone', pl: 'Telefon' },
  street: { en: 'Street', pl: 'Ulica' },
  postcode: { en: 'Postcode', pl: 'Kod pocztowy' },
  city: { en: 'City', pl: 'Miasto' },
  country: { en: 'Country', pl: 'Kraj' },
  closed: { en: 'Closed', pl: 'Zamknięte' },
  servicesFor: {
    en: 'Services for',
    pl: 'Usługi dla',
  },
  newPassword: {
    en: 'New password',
    pl: 'Nowe hasło',
  },
  password: {
    en: 'Password',
    pl: 'Hasło',
  },
  companyName: {
    en: 'Company Name',
    pl: 'Naszwa firma',
  },
  companyNip: {
    en: 'Company NIP',
    pl: 'NIP firmy',
  },
  createAccount: {
    en: 'Create an account',
    pl: 'Zarejestruj konto',
  },
  pleaseActivateAccount: {
    en: 'Activate your account!',
    pl: 'Proszę aktywować konto!',
  },
  pleaseCreateAccount: {
    en: 'Please create an account',
    pl: 'Proszę założyć konto',
  },
  alreadyHaveAccount: {
    en: 'Already have an account?',
    pl: 'Masz już konto?',
  },
  bySigning: {
    en: 'By signing up you agree to our ',
    pl: 'Rejestrując się wyrażasz zgodę na nasze',
  },
  termsOfService: {
    en: 'Terms of Service',
    pl: 'Warunki Usługi',
  },
  privacyPolicy: {
    en: 'Privacy Policy',
    pl: 'Polityka prywatności',
  },
  rightsReserved: {
    en: 'All rights reserved',
    pl: 'Prawa zastrzeżone',
  },
  hasTranslations: {
    en: 'Translations',
    pl: 'Tłumaczenia',
  },
  directContact: {
    en: 'Direct Contact',
    pl: 'Kontakt bezpośredni',
  },
  passDiscount: {
    en: 'For regularly training clients, the option to purchase a pass for 5 lessons valid for 5 weeks from the date of purchase (-10zł off the regular price)',
    pl: 'Dla regularnie trenujących klientów możliwość zakupu karnetu na 5 jazd ważnego przez 5tyg. od dnia zakupu (-10zł od ceny regularnej)',
  },
  pricingIntro: {
    en: 'Choose the path that fits your goals.',
    pl: 'Wybierz ścieżkę, która pasuje do Twoich celów.',
  },
  pricingPensionTitle: {
    en: 'Premium Pension',
    pl: 'Pensjonat Premium',
  },
  pricingPensionDesc: {
    en: 'Full-service horse boarding with premium care.',
    pl: 'Pełna opieka nad koniem z usługami premium.',
  },
  pricingPensionFrom: {
    en: 'Starting at',
    pl: 'Począwszy od',
  },
  pricingPensionCTA: {
    en: 'Request Quote',
    pl: 'Zapytaj o cenę',
  },
  pricingTrainingTitle: {
    en: 'Training Programs',
    pl: 'Programy Treningowe',
  },
  pricingTrainingDesc: {
    en: 'Professional partnership-based training for horse and rider.',
    pl: 'Profesjonalny trening dla konia i jeźdźca oparty na partnerstwie.',
  },
  pricingTrainingFrom: {
    en: 'from',
    pl: 'od',
  },
  pricingTrainingCTA: {
    en: 'Inquire',
    pl: 'Zapytaj',
  },
  pricingFeature1: {
    en: '24/7 care & monitoring',
    pl: 'Opieka i monitoring 24/7',
  },
  pricingFeature2: {
    en: 'Daily turnout & exercise',
    pl: 'Codzienny wypas i ćwiczenia',
  },
  pricingFeature3: {
    en: 'Premium feed program',
    pl: 'Program żywienia premium',
  },
  pricingFeature4: {
    en: 'Individual attention',
    pl: 'Indywidualna uwaga',
  },
  pricingFeature5: {
    en: 'Personalized training plans',
    pl: 'Spersonalizowane plany treningowe',
  },
  pricingFeature6: {
    en: 'Biomechanics-focused approach',
    pl: 'Podejście oparte na biomechanice',
  },
  pricingFeature7: {
    en: 'Jump & dressage training',
    pl: 'Trening skoków i ujeżdżenia',
  },
  pricingFeature8: {
    en: 'Progress tracking',
    pl: 'Śledzenie postępów',
  },
  pricingDetailsTitle: {
    en: 'Individual Session Pricing',
    pl: 'Cennik Pojedynczych Sesji',
  },
  teamPonchoDesc: {
    en: 'Poncho is the owner, a tennis player 🎾, and trilingual 🌍. He brings energy from the court to the arena and keeps the stable vibes upbeat.',
    pl: 'Poncho jest właścicielem, tenisistą 🎾 i osobą trójjęzyczną 🌍. Przenosi energię z kortu na arenę i dba o dobrą atmosferę w stajni.',
  },
  teamBasiaDesc: {
    en: 'Barbara is the owner and head coach, a show-jumping rider 🐎. She leads training with precision, calm focus, and a champion’s mindset.',
    pl: 'Barbara jest właścicielką i główną trenerką, zawodniczką skoków 🐎. Prowadzi treningi z precyzją, spokojem i mentalnością mistrzyni.',
  },
  teamJaroDesc: {
    en: 'Jarosław is the co-owner, rider, and DAAS provider 📊🐴. He blends saddle time with data-driven support so riders feel confident and informed.',
    pl: 'Jarosław jest współwłaścicielem, jeźdźcem i DAAS providerem 📊🐴. Łączy czas w siodle z wsparciem opartym na danych, by jeźdźcy czuli się pewnie i świadomie.',
  },
  teamZosiaDesc: {
    en: 'Sussane is a trainer, rider, and stable manager 🧹🐴. She keeps horses happy, routines smooth, and every detail in sync.',
    pl: 'Zuzanna jest trenerką, amazonką i menedżerką stajni 🧹🐴. Dba o zadowolenie koni, płynność pracy i dopięcie każdego detalu.',
  },
  horseSectionTitle: {
    en: 'Horses for sale',
    pl: 'Konie na sprzedaż',
  },
  horseSectionSubtitle: {
    en: '8-year-old chestnut SP gelding that is competition-ready and easy to fall in love with.',
    pl: '8-letni kasztanowaty wałach SP, gotowy do startów i łatwy do pokochania.',
  },
  horseDisciplineTag: {
    en: 'Showjumping / all-round sport',
    pl: 'Skoki / koń wszechstronny',
  },
  horsePriceLabel: {
    en: 'Price',
    pl: 'Cena',
  },
  horsePriceValue: {
    en: '40 000 PLN',
    pl: '40 000 zł',
  },
  horseCTACall: {
    en: 'Call',
    pl: 'Zadzwoń',
  },
  horseCTAContact: {
    en: 'Book a test ride',
    pl: 'Umów jazdę próbną',
  },
  horseCTAListing: {
    en: 'See full listing',
    pl: 'Zobacz ogłoszenie',
  },
  horseSaleProfile: {
    en: '2018 | 8 y/o chestnut SP gelding, elastic with scope, shown to L (1.00m) and schooling higher at home.',
    pl: '2018 | 8-letni kasztanowaty wałach SP, elastyczny z zapasem mocy, starty do L (1.00 m), w domu skacze wyżej.',
  },
  horseSaleTemperament: {
    en: 'Brave in new places, rides out solo or in a group, dog-friendly, straightforward to load and travel.',
    pl: 'Odważny w nowych miejscach, chodzi w teren sam i w grupie, przyjazny psom, bezproblemowy w załadunku i transporcie.',
  },
  horseSaleTraining: {
    en: 'Consistent flatwork (rhythm, laterals, balance) and clean groundwork: lunging, poles, and gymnastic lines.',
    pl: 'Regularnie szkolony: rytm, praca boczna, równowaga, czysta praca z ziemi – lonża, drążki, linie gimnastyczne.',
  },
  horseSaleHealth: {
    en: 'Under farrier, physio, and saddle-fitter care; past knee arthroscopy fully rehabbed, currently sound and in work.',
    pl: 'Pod stałą opieką kowala, fizjo i saddle-fitera; po artroskopii kolana, w pełni zrehabilitowany, zdrowy i w treningu.',
  },
  horseSaleExtras: {
    en: 'Comes with a fitted tack set; vaccines, deworming, teeth, and passport fully up to date.',
    pl: 'Sprzedawany z dopasowanym kompletem sprzętu; paszport, szczepienia, odrobaczanie i zęby aktualne.',
  },
  horseSaleLocation: {
    en: 'Location: Iłża (Mazowieckie) • Contact: (+48) 729 883 891',
    pl: 'Lokalizacja: Iłża (Mazowieckie) • Kontakt: (+48) 729 883 891',
  },
  horseSaleLogistics: {
    en: 'We can arrange a demo ride, vet check support, and transport across Poland or the EU.',
    pl: 'Możemy zorganizować jazdę pokazową, wsparcie przy badaniu weterynaryjnym i transport w Polsce lub UE.',
  },
  // Horse Details
  horseSex: { en: 'Sex', pl: 'Płeć' },
  horseSexGelding: { en: 'Gelding', pl: 'Wałach' },
  horseBirthDate: { en: 'Birth Date', pl: 'Data urodzenia' },
  horseBirthYear: { en: '2018 (8 years)', pl: '2018 (8 lat)' },
  horsePurpose: { en: 'Purpose', pl: 'Przeznaczenie' },
  horseJumping: { en: 'Jumping', pl: 'Skoki' },
  horseCoat: { en: 'Coat', pl: 'Maść' },
  horseChestnut: { en: 'Chestnut', pl: 'Kasztanowata' },
  horseBreed: { en: 'Breed', pl: 'Rasa' },
  horseBreedType: { en: 'SP noble half-breed', pl: 'SP szlachetna półkrew' },
  horseOtherPurposes: { en: 'Other purposes', pl: 'Inne przeznaczenia' },
  horseDressage: { en: 'Dressage', pl: 'Ujeżdżenie' },
  horseCharacterTitle: { en: 'Character & Temperament', pl: 'Charakter i temperament' },
  horseProfessor: { en: 'Professor horse', pl: 'Koń profesor' },
  horseBeginners: { en: 'For beginners', pl: 'Dla początkującego' },
  horseExperienced: { en: 'For experienced', pl: 'Dla doświadczonego' },
  horseTerrain: { en: 'Goes in terrain', pl: 'Chodzi w tereny' },
  horseDogFriendly: { en: 'Used to dogs', pl: 'Przyzwyczajony do psów' },
  horseCompetitionTitle: { en: 'Competition starts', pl: 'Starty w zawodach' },
  horseSocial: { en: 'Social', pl: 'Towarzyskie' },
  horseRegional: { en: 'Regional', pl: 'Regionalne' },
  horseFeaturesTitle: { en: 'Other features', pl: 'Inne cechy' },
  horseTransport: { en: 'Gentle in transport', pl: 'Grzeczny w transporcie' },
  horseFarrier: { en: 'Used to farrier', pl: 'Przyzwyczajony do kowala' },
  horseHooves: { en: 'Correct hooves', pl: 'Prawidłowe kopyta' },
  horseGroundwork: { en: 'Can work from ground', pl: 'Umie pracować z ziemi' },
  horseWithEquipment: { en: 'For sale with equipment', pl: 'Do sprzedaży ze sprzętem' },
  horsePhysiotherapy: { en: 'Under physiotherapist care', pl: 'Pod opieką fizjoterapeuty' },
  // Add more translations as needed
};

export default labelTranslations;
